
import React, { useCallback } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface WaitlistFormProps {
  email: string;
  setEmail: (email: string) => void;
  handleWaitlistSubmit: (e: React.FormEvent) => void;
  buttonText?: string;
  className?: string;
}

const WaitlistForm: React.FC<WaitlistFormProps> = ({
  email,
  setEmail,
  handleWaitlistSubmit,
  buttonText = "Join the Waitlist",
  className = ""
}) => {
  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  }, [setEmail]);

  return (
    <form onSubmit={handleWaitlistSubmit} className={`${className}`}>
      <div className="flex flex-col sm:flex-row gap-2 justify-center">
        <Input
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={handleInputChange}
          className="flex-grow"
          required
          aria-label="Email address"
        />
        <Button 
          type="submit" 
          variant="default" 
          size="default" 
          className="whitespace-nowrap"
          aria-label={buttonText}
        >
          {buttonText}
        </Button>
      </div>
    </form>
  );
};

export default React.memo(WaitlistForm);
